import { LatamHomePage } from '@/screens/Latam/Home/LatamHomePage';

export default function PlatformPage() {
  return <LatamHomePage locale="pt-BR" />;
}
